import { createElement, FC, HTMLAttributes, ReactNode } from 'react';

export type MetaProps = {
  children: ReactNode;
  className?: string;
  /**
   * The element to render. A span lets a meta line sit inline - for example the
   * save-state status beside a button - while the paragraph stays the default.
   */
  as?: 'p' | 'span';
} & Omit<HTMLAttributes<HTMLElement>, 'children' | 'className'>;

/** The one metadata line. */
const Meta: FC<MetaProps> = ({ children, className, as = 'p', ...rest }) =>
  createElement(as, { className: ['ui-meta', className].filter(Boolean).join(' '), ...rest }, children);

export default Meta;
